var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuestionMark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 91.19,
    height: 81.938,
    viewBox: "0 0 91.19 81.938",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16239",
    "data-name": "Grupo 16239",
    transform: "translate(-639.395 -286.141)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15056",
    "data-name": "Grupo 15056",
    transform: "translate(844.908 271.658)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Uni\\xF3n_17",
    "data-name": "Uni\\xF3n 17",
    d: "M4.1,57.793H88.3S69.16,80.3,41.635,80.909q-.524.012-1.039.012C13.858,80.921,4.1,57.793,4.1,57.793Zm.141,0S-2.359,49.259.907,32.776c2.053-10.368,10.679-15.5,22.242-15.014,3.975.169,10.443-4.855,19.734-11.026C62.76-6.464,91.512-.858,84.63,28.832,81.3,43.2,95.1,43.431,88.244,57.793Z",
    transform: "translate(-205 15)",
    fill: "#d5dced",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1,
    opacity: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "manual",
    transform: "translate(663.8 306.663)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_76310",
    "data-name": "Trazado 76310",
    d: "M28.917,51.438H11.767A8.583,8.583,0,0,1,3.2,42.871V8.57A8.583,8.583,0,0,1,11.767,0a1.72,1.72,0,1,1,0,3.424A5.143,5.143,0,0,0,6.624,8.57v34.3a5.143,5.143,0,0,0,5.143,5.143h17.15a1.72,1.72,0,1,1,0,3.424Z",
    transform: "translate(0 0)",
    fill: "#18a8a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_76311",
    "data-name": "Trazado 76311",
    d: "M30.663,51.438a1.72,1.72,0,1,1,0-3.424,5.143,5.143,0,0,0,5.143-5.143V8.57a5.143,5.143,0,0,0-5.143-5.143H13.513a1.72,1.72,0,1,1,0-3.424h17.15A8.583,8.583,0,0,1,39.23,8.57v34.3a8.583,8.583,0,0,1-8.567,8.567Z",
    transform: "translate(5.118 0)",
    fill: "#18a8a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_76312",
    "data-name": "Trazado 76312",
    d: "M26.153,22.627H12.443a1.72,1.72,0,1,1,0-3.424H26.153a1.72,1.72,0,1,1,0,3.424Z",
    transform: "translate(4.468 11.661)",
    fill: "#18a8a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_76313",
    "data-name": "Trazado 76313",
    d: "M23.8,26.9H13.513a1.72,1.72,0,1,1,0-3.424H23.8a1.72,1.72,0,1,1,0,3.424Z",
    transform: "translate(5.118 14.254)",
    fill: "#18a8a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_76314",
    "data-name": "Trazado 76314",
    d: "M17.252,18.395a1.72,1.72,0,0,1-1.72-1.72v-.932a3.086,3.086,0,0,1,3.086-3.086,1.029,1.029,0,0,0,1.045-1.013V9.522A1.029,1.029,0,0,0,18.651,8.51H17.268a1.013,1.013,0,0,0-1.013,1.013,1.728,1.728,0,0,1-3.456,0A4.452,4.452,0,0,1,17.252,5.07h1.382a4.452,4.452,0,0,1,4.452,4.452v2.122a4.452,4.452,0,0,1-4.131,4.436v.595a1.72,1.72,0,0,1-1.7,1.72Z",
    transform: "translate(5.83 3.082)",
    fill: "#ee2b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_76315",
    "data-name": "Trazado 76315",
    d: "M16.22,17.86a1.72,1.72,0,1,1,1.72-1.72,1.72,1.72,0,0,1-1.72,1.72Z",
    transform: "translate(6.863 8.761)",
    fill: "#ee2b7b"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMark);
export default __webpack_public_path__ + "static/media/question-mark.3e58597147c13614292a5c553ea6ae2b.svg";
export { ForwardRef as ReactComponent };